<template>
  <div class="grading-panel">
    <div class="content-wrapper">
      <div class="top-bar">
        <button class="back-btn" @click="goBack">
          <span class="arrow-icon"></span>
        </button>
        <h2>Moasure Viewer</h2>
        <div class="help-icon-wrapper">
          <v-icon @click="openApp" class="help-icon" dark color="white">
            mdi-help-circle-outline
          </v-icon>
        </div>
      </div>
      <!-- <div class="control-group mt-1">
        <v-btn @click="openApp">Open App</v-btn>
      </div> -->
      <!-- <div class="control-group mt-1"> -->
      <!-- <label>Result</label> -->
      <!-- <v-card elevation="16" max-width="344">
          <v-card-item>
            <v-card-title> Card title </v-card-title>

            <v-card-subtitle> Card subtitle secondary text </v-card-subtitle>
          </v-card-item>

          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </v-card-text>
        </v-card> -->
      <!-- </div> -->

      <div class="drawing-container relative">
        <!-- View toggle controls -->
        <!-- <div class="controls mb-4">
          <button
            @click="toggleView('2d')"
            :class="[
              'px-3 py-1 mr-2 rounded text-white hover:bg-blue-700',
              viewMode === '2d' ? 'bg-blue-600' : 'bg-gray-600',
            ]"
          >
            2D View
          </button>
          <button
            @click="toggleView('3d')"
            :class="[
              'px-3 py-1 rounded text-white hover:bg-blue-700',
              viewMode === '3d' ? 'bg-blue-600' : 'bg-gray-600',
            ]"
          >
            3D View
          </button>
        </div> -->

        <!-- Floating Panel -->
        <div v-if="viewMode === '3d'" class="object-floating-panel">
          <div :class="panelStyle">
            <h3 class="panel-title">Object Info</h3>
            <button @click="togglePanel" class="panel-toggle">
              <v-icon color="white" v-if="!isPanelCollapsed"
                >mdi-arrow-left-box
              </v-icon>
              <v-icon color="white" v-else>mdi-arrow-right-box </v-icon>

              <!-- {{ isPanelCollapsed ? '->' : '←' }} -->
            </button>
          </div>

          <div class="view-btns" v-show="!isPanelCollapsed">
            <v-btn
              @click="switchToSurfaceView"
              class="mr-4"
              :color="surfaceBtnColor"
            >
              <svg
                v-show="!showSurface"
                width="39"
                height="21"
                viewBox="0 0 39 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.1064 5.39997L19.8394 6.49997C18.5964 5.74097 17.0784 2.35296 15.7914 1.16496C14.5044 -0.0230387 13.4044 1.73698 12.2164 4.21198C11.0284 6.68698 9.25738 8.93098 8.68538 9.26098C8.11338 9.59098 3.2074 11.076 3.2074 11.076"
                  stroke="white"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M27.5505 7.74298L26.3735 8.14998C26.1755 8.21598 25.9555 8.23798 25.7465 8.19398C25.3725 8.11698 24.7015 8.10597 24.2615 8.83197C23.6235 9.86597 22.3805 12.143 21.4015 11.087C20.4225 10.031 19.1795 6.09296 17.5625 10.339C15.9455 14.596 14.9115 14.563 14.9115 14.563L12.4585 15.476"
                  stroke="white"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M19.7955 6.42713C19.7955 6.42713 17.8469 5.14475 16.9408 5.44572C16.0249 5.74668 15.7229 6.53185 14.6706 8.95268C13.6086 11.3735 12.8487 12.669 11.1631 13.0746C11.1631 13.0746 9.35089 13.8205 8.79553 14.2"
                  stroke="white"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M34.0955 10.9L31.5533 11.4335C31.3438 11.4917 29.6396 11.6081 29.4161 11.6372C28.6758 11.7148 26.0079 11.1231 25.3514 11.9379C24.5133 12.9758 23.8847 15.915 20.8955 16.4"
                  stroke="white"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M0.842367 10.3279L2.52537 10.4929L17.0014 17.2029L16.4184 18.0389L0.0723877 10.3279H0.842367Z"
                  fill="white"
                />
                <path
                  d="M9.78537 8.117L2.52537 10.493L0.0723877 10.328L10.7424 6.78601L9.78537 8.117Z"
                  fill="white"
                />
                <path
                  d="M16.7595 17.1259L20.3345 16.0479C20.3345 16.0479 21.7975 15.8169 22.4025 17.3789C23.2495 19.5679 24.2725 19.2929 24.8225 18.4569C25.3725 17.6209 27.0995 14.4419 27.9685 14.1669C28.8375 13.8919 35.5585 11.7799 35.5585 11.7799L38.0335 12.0659L29.1125 14.9479C29.1125 14.9479 28.1885 15.3659 27.9355 15.8499C27.7155 16.2569 25.9995 19.1059 25.3395 19.9199C25.1965 20.0959 24.9215 20.3269 24.7125 20.4149C24.2505 20.6129 23.5245 20.6239 22.8755 20.0299C21.9295 19.1609 21.0605 17.5549 21.0605 17.5549C21.0605 17.5549 20.6975 17.0819 20.0925 17.3679L17.0015 18.3469L14.4385 17.0819L16.7595 17.1259Z"
                  fill="white"
                />
                <path
                  d="M18.2004 4.35491L20.3235 3.67291L38.0225 12.0879L36.8785 12.4289L20.3565 4.58593L18.7395 5.12492L18.2004 4.35491Z"
                  fill="white"
                />
              </svg>
              <svg
                v-show="showSurface"
                width="39"
                height="21"
                viewBox="0 0 39 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.1064 5.39997L19.8394 6.49997C18.5964 5.74097 17.0784 2.35296 15.7914 1.16496C14.5044 -0.0230387 13.4044 1.73698 12.2164 4.21198C11.0284 6.68698 9.25738 8.93098 8.68538 9.26098C8.11338 9.59098 3.2074 11.076 3.2074 11.076"
                  stroke="black"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M27.5505 7.74298L26.3735 8.14998C26.1755 8.21598 25.9555 8.23798 25.7465 8.19398C25.3725 8.11698 24.7015 8.10597 24.2615 8.83197C23.6235 9.86597 22.3805 12.143 21.4015 11.087C20.4225 10.031 19.1795 6.09296 17.5625 10.339C15.9455 14.596 14.9115 14.563 14.9115 14.563L12.4585 15.476"
                  stroke="black"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M19.7955 6.42713C19.7955 6.42713 17.8469 5.14475 16.9408 5.44572C16.0249 5.74668 15.7229 6.53185 14.6706 8.95268C13.6086 11.3735 12.8487 12.669 11.1631 13.0746C11.1631 13.0746 9.35089 13.8205 8.79553 14.2"
                  stroke="black"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M34.0955 10.9L31.5533 11.4335C31.3438 11.4917 29.6396 11.6081 29.4161 11.6372C28.6758 11.7148 26.0079 11.1231 25.3514 11.9379C24.5133 12.9758 23.8847 15.915 20.8955 16.4"
                  stroke="black"
                  stroke-width="0.55"
                  stroke-miterlimit="10"
                />
                <path
                  d="M0.842367 10.3279L2.52537 10.4929L17.0014 17.2029L16.4184 18.0389L0.0723877 10.3279H0.842367Z"
                  fill="black"
                />
                <path
                  d="M9.78537 8.117L2.52537 10.493L0.0723877 10.328L10.7424 6.78601L9.78537 8.117Z"
                  fill="black"
                />
                <path
                  d="M16.7595 17.1259L20.3345 16.0479C20.3345 16.0479 21.7975 15.8169 22.4025 17.3789C23.2495 19.5679 24.2725 19.2929 24.8225 18.4569C25.3725 17.6209 27.0995 14.4419 27.9685 14.1669C28.8375 13.8919 35.5585 11.7799 35.5585 11.7799L38.0335 12.0659L29.1125 14.9479C29.1125 14.9479 28.1885 15.3659 27.9355 15.8499C27.7155 16.2569 25.9995 19.1059 25.3395 19.9199C25.1965 20.0959 24.9215 20.3269 24.7125 20.4149C24.2505 20.6129 23.5245 20.6239 22.8755 20.0299C21.9295 19.1609 21.0605 17.5549 21.0605 17.5549C21.0605 17.5549 20.6975 17.0819 20.0925 17.3679L17.0015 18.3469L14.4385 17.0819L16.7595 17.1259Z"
                  fill="black"
                />
                <path
                  d="M18.2004 4.35491L20.3235 3.67291L38.0225 12.0879L36.8785 12.4289L20.3565 4.58593L18.7395 5.12492L18.2004 4.35491Z"
                  fill="black"
                />
              </svg>

              <span v-if="!showSurface" class="pl-1 btn-text">3D</span>
              <span v-else class="pl-1">3D </span></v-btn
            >

            <v-btn :color="threeDBtnColor" @click="switchTo3DView">
              <svg
                v-if="!showSurface"
                width="39"
                height="22"
                viewBox="0 0 39 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.79544 11.0901L1.77052 7.27232C1.45804 7.10258 1.08904 7.10959 0.783272 7.29136C0.477501 7.47308 0.295044 7.79394 0.295044 8.14966V17.0061C0.295044 17.3645 0.488547 17.6971 0.800078 17.8742L7.82513 21.8679C7.97999 21.956 8.14934 21.9999 8.31873 21.9999C8.49134 21.9999 8.66392 21.9542 8.82084 21.8629C9.13164 21.6821 9.31719 21.3594 9.31719 20.9998V11.9675C9.31719 11.6013 9.11733 11.2651 8.79544 11.0901Z"
                  fill="black"
                />
                <path
                  d="M18.6503 4.96869C18.6498 4.59475 18.4433 4.25558 18.1113 4.08353L10.4509 0.112063C10.1608 -0.0383725 9.81512 -0.037255 9.52615 0.114857L1.97836 4.08632C1.64972 4.25932 1.4453 4.59746 1.44482 4.96886C1.4444 5.34018 1.648 5.67879 1.97616 5.85252L9.524 9.84879C9.67014 9.92611 9.83059 9.96479 9.99113 9.96479C10.1497 9.96479 10.3083 9.92706 10.453 9.85154L18.1136 5.85536C18.4451 5.6824 18.6508 5.34263 18.6503 4.96869Z"
                  fill="black"
                />
                <path
                  d="M19.4368 7.29143C19.1312 7.10966 18.762 7.10248 18.4496 7.27235L11.4245 11.0902C11.1027 11.2651 10.9028 11.6013 10.9028 11.9675V20.9998C10.9028 21.3595 11.0884 21.6821 11.3992 21.8629C11.5561 21.9543 11.7286 21.9999 11.9013 21.9999C12.0706 21.9999 12.2401 21.956 12.3949 21.868L19.42 17.8742C19.7315 17.6971 19.925 17.3645 19.925 17.0061V8.14973C19.925 7.79401 19.7425 7.47316 19.4368 7.29143Z"
                  fill="black"
                />
              </svg>
              <svg
                v-else
                width="39"
                height="22"
                viewBox="0 0 39 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.79544 11.0901L1.77052 7.27232C1.45804 7.10258 1.08904 7.10959 0.783272 7.29136C0.477501 7.47308 0.295044 7.79394 0.295044 8.14966V17.0061C0.295044 17.3645 0.488547 17.6971 0.800078 17.8742L7.82513 21.8679C7.97999 21.956 8.14934 21.9999 8.31873 21.9999C8.49134 21.9999 8.66392 21.9542 8.82084 21.8629C9.13164 21.6821 9.31719 21.3594 9.31719 20.9998V11.9675C9.31719 11.6013 9.11733 11.2651 8.79544 11.0901Z"
                  fill="white"
                />
                <path
                  d="M18.6503 4.96869C18.6498 4.59475 18.4433 4.25558 18.1113 4.08353L10.4509 0.112063C10.1608 -0.0383725 9.81512 -0.037255 9.52615 0.114857L1.97836 4.08632C1.64972 4.25932 1.4453 4.59746 1.44482 4.96886C1.4444 5.34018 1.648 5.67879 1.97616 5.85252L9.524 9.84879C9.67014 9.92611 9.83059 9.96479 9.99113 9.96479C10.1497 9.96479 10.3083 9.92706 10.453 9.85154L18.1136 5.85536C18.4451 5.6824 18.6508 5.34263 18.6503 4.96869Z"
                  fill="white"
                />
                <path
                  d="M19.4368 7.29143C19.1312 7.10966 18.762 7.10248 18.4496 7.27235L11.4245 11.0902C11.1027 11.2651 10.9028 11.6013 10.9028 11.9675V20.9998C10.9028 21.3595 11.0884 21.6821 11.3992 21.8629C11.5561 21.9543 11.7286 21.9999 11.9013 21.9999C12.0706 21.9999 12.2401 21.956 12.3949 21.868L19.42 17.8742C19.7315 17.6971 19.925 17.3645 19.925 17.0061V8.14973C19.925 7.79401 19.7425 7.47316 19.4368 7.29143Z"
                  fill="white"
                />
              </svg>

              <span v-if="!showSurface" class="">3D</span
              ><span v-else class="btn-text">3D</span></v-btn
            >
          </div>

          <div v-if="!isPanelCollapsed" class="panel-content">
            <div class="measurement-info">
              <p class="info-item">
                <span class="info-label">Total Points:</span>
                <span class="info-value">{{ pausePoints.length }}</span>
              </p>
              <p class="info-item">
                <span class="info-label">Perimeter:</span>
                <span class="info-value">{{ distance.toFixed(2) }} m</span>
              </p>

              <p v-if="selectedPoints.length > 1" class="info-item">
                <span class="info-label">Rise:</span>
                <span class="info-value">{{ rise }} m</span>
              </p>
              <p v-if="selectedPoints.length > 1" class="info-item">
                <span class="info-label">Run:</span>
                <span class="info-value">{{ run }} m</span>
              </p>

              <v-btn
                v-if="selectedPoints.length == 2"
                class="mr-4 mt-2"
                color="#0DD7B5"
              >
                View Cross Section
              </v-btn>

              <p class="info-item" v-if="surfaceMesh">
                <span class="info-label">Volume:</span>
                <span class="info-value">{{ volume }} m&#179;</span>
              </p>
              <p class="info-item" v-if="surfaceMesh">
                <span class="info-label">Surface Area:</span>
                <span class="info-value">{{ surfaceArea }} m</span>
              </p>
              <p class="info-item" v-if="selectedTool == 'cut-fill'">
                <span class="info-label">Cut Plane Level:</span>
                <span class="info-value">{{ gradePlaneHeight }} m&#179;</span>
              </p>
              <p class="info-item" v-if="selectedTool == 'cut-fill'">
                <span class="info-label">Cut Volume:</span>
                <span class="info-value">{{ cutVolume }} m&#179;</span>
              </p>
              <p class="info-item" v-if="selectedTool == 'cut-fill'">
                <span class="info-label">Fill Volume:</span>
                <span class="info-value">{{ fillVolume }} m&#179;</span>
              </p>
            </div>

            <div class="selected-points" v-if="selectedPoints.length > 0">
              <h4 class="section-title">Selected Points</h4>
              <div
                v-for="(point, index) in selectedPoints"
                :key="index"
                class="point-item"
              >
                <span class="point-index">Point {{ index + 1 }}:</span>
                <span class="point-coords">
                  X: {{ point[0].toFixed(2) }}, Y: {{ point[1].toFixed(2) }}, Z:
                  {{ point[2].toFixed(2) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- tools -->
        <div
          v-if="viewMode === '3d'"
          class="floating-panel tools-panel"
          :class="{ 'panel-collapsed': isToolsPanelCollapsed }"
        >
          <div :class="toolPanelStyle">
            <h3 class="panel-title">Tools</h3>
            <button @click="toggleToolsPanel" class="panel-toggle">
              <v-icon color="white" v-if="!isToolsPanelCollapsed"
                >mdi-arrow-right-box
              </v-icon>
              <v-icon v-else color="white">mdi-arrow-left-box </v-icon>
            </button>
          </div>
          <div v-if="!isToolsPanelCollapsed" class="panel-content">
            <div class="tools-grid">
              <div
                v-for="tool in tools"
                :key="tool.id"
                class="tool-item"
                :class="{ active: selectedTool === tool.id }"
                @click="selectTool(tool.id)"
              >
                <v-icon dark>{{ tool.icon }}</v-icon>
                <span class="tool-label">{{ tool.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 2D SVG View remains the same -->
        <svg
          v-if="viewMode === '2d'"
          :viewBox="viewBox"
          class="w-full h-full"
          style="background: #1a1a1a"
        >
          <!-- SVG content remains the same -->
        </svg>

        <!-- 3D Three.js View remains the same -->
        <div v-show="viewMode === '3d'" ref="container" class="three-container">
          <div v-if="!scene" class="loading-overlay">
            <span>Loading 3D View...</span>
          </div>
        </div>

        <!-- <div class="mt-2 text-white text-sm">
          {{ error }} Total Points: {{ pausePoints.length }} | Distance:
          {{ distance.toFixed(2) }} units
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry';
import { ConvexHull } from 'three/examples/jsm/math/ConvexHull';
import { Delaunay } from 'd3-delaunay';

import '../swal.css';

function getColorForHeight(height, minHeight, maxHeight) {
  // Normalize height to 0-1 range
  const normalizedHeight = (height - minHeight) / (maxHeight - minHeight);

  // Define color stops (yellow to orange to red)
  const colors = [
    { pos: 0, color: new THREE.Color(0xffeb3b) }, // Yellow
    { pos: 0.5, color: new THREE.Color(0xff9800) }, // Orange
    { pos: 1, color: new THREE.Color(0xff5252) }, // Red
  ];

  // Find the two colors to interpolate between
  let colorIndex = 0;
  for (let i = 0; i < colors.length - 1; i++) {
    if (
      normalizedHeight >= colors[i].pos &&
      normalizedHeight <= colors[i + 1].pos
    ) {
      colorIndex = i;
      break;
    }
  }

  // Calculate local interpolation factor between the two colors
  const localFactor =
    (normalizedHeight - colors[colorIndex].pos) /
    (colors[colorIndex + 1].pos - colors[colorIndex].pos);

  // Interpolate between colors
  const color = new THREE.Color();
  color.lerpColors(
    colors[colorIndex].color,
    colors[colorIndex + 1].color,
    localFactor
  );

  return color;
}

function calculateTriangleArea(p1, p2, p3) {
  const a = new THREE.Vector3().subVectors(p2, p1);
  const b = new THREE.Vector3().subVectors(p3, p1);
  const cross = new THREE.Vector3().crossVectors(a, b);
  return cross.length() / 2;
}

function calculateTetrahedronVolume(p1, p2, p3, baseHeight = 0) {
  // Create base triangle points at height 0
  const base1 = new THREE.Vector3(p1.x, baseHeight, p1.z);
  const base2 = new THREE.Vector3(p2.x, baseHeight, p2.z);
  const base3 = new THREE.Vector3(p3.x, baseHeight, p3.z);

  // Create surface points
  const surface1 = new THREE.Vector3(p1.x, p1.y, p1.z);
  const surface2 = new THREE.Vector3(p2.x, p2.y, p2.z);
  const surface3 = new THREE.Vector3(p3.x, p3.y, p3.z);

  // Calculate volume using signed tetrahedron volume formula
  const v321 = surface3.x * surface2.y * surface1.z;
  const v231 = surface2.x * surface3.y * surface1.z;
  const v312 = surface3.x * surface1.y * surface2.z;
  const v132 = surface1.x * surface3.y * surface2.z;
  const v213 = surface2.x * surface1.y * surface3.z;
  const v123 = surface1.x * surface2.y * surface3.z;

  const volume = (1.0 / 6.0) * (-v321 + v231 + v312 - v132 - v213 + v123);
  return Math.abs(volume); // Return absolute value for positive volume
}

function isPointInPolygon(point, polygon) {
  // Ray casting algorithm for point-in-polygon test
  let inside = false;
  const x = point[0],
    y = point[1];

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0],
      yi = polygon[i][1];
    const xj = polygon[j][0],
      yj = polygon[j][1];

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }

  return inside;
}

function createPerimeterTriangulation(points) {
  if (!points || points.length < 3) return null;

  // Create 2D points array for triangulation
  const points2D = points.map((point) => [point[0], -point[1]]);

  // Create the Delaunay triangulation
  const delaunay = Delaunay.from(points2D);
  const triangles = Array.from(delaunay.triangles);

  // Create polygon from perimeter points
  const perimeterPolygon = points2D.map((p) => [p[0], p[1]]);

  // Filter triangles that are within or intersect the perimeter
  const validTriangles = [];
  for (let i = 0; i < triangles.length; i += 3) {
    const triangle = [
      points2D[triangles[i]],
      points2D[triangles[i + 1]],
      points2D[triangles[i + 2]],
    ];

    // Calculate triangle centroid
    const centroid = [
      (triangle[0][0] + triangle[1][0] + triangle[2][0]) / 3,
      (triangle[0][1] + triangle[1][1] + triangle[2][1]) / 3,
    ];

    // Check if centroid is inside the polygon
    if (isPointInPolygon(centroid, perimeterPolygon)) {
      validTriangles.push(triangles[i], triangles[i + 1], triangles[i + 2]);
    }
  }

  // Create geometry with filtered triangles
  const geometry = new THREE.BufferGeometry();

  // Create vertices array
  const vertices = new Float32Array(points.length * 3);
  points.forEach((point, i) => {
    vertices[i * 3] = point[0]; // x
    vertices[i * 3 + 1] = point[2]; // y (height)
    vertices[i * 3 + 2] = -point[1]; // z
  });

  geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
  geometry.setIndex(validTriangles);

  return geometry;
}

export default {
  name: 'GradingApp',
  data() {
    return {
      viewBox: '0 0 100 100',
      pathData: '',
      pausePoints: [],
      distance: 0,
      volume: 0,
      cutVolume: 0,
      fillVolume: 0,
      gradePlaneHeight: 0,
      colorMode: 'height',
      planeHeight: 0,
      surfaceArea: 0,
      viewMode: '3d',
      moasureResult: null,
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      points: null,
      lines: null,
      pointsGroup: null,
      isProcessing: false,
      raycaster: new THREE.Raycaster(),
      mouse: new THREE.Vector2(),
      error: '',
      selectedPoints: [],
      measurementLine: null,
      measurementLabels: [],
      isPanelCollapsed: false,
      isToolsPanelCollapsed: false,
      selectedTool: 'rotate',
      tools: [
        { id: 'label', icon: 'mdi-label', label: 'Label Point' },
        { id: 'Open', icon: 'mdi-shape-circle-plus', label: 'Open' },
        { id: 'cut-fill', icon: 'mdi-excavator', label: 'Cut/Fill' },
        { id: 'measure', icon: 'mdi-ruler', label: 'Measure' },
        { id: 'reset', icon: 'mdi-refresh', label: 'Reset' },
        { id: 'ignore', icon: 'mdi-vector-line', label: 'Ignore' },
        // {
        //   id: 'volume',
        //   icon: 'mdi-cube-outline',
        //   label: 'Calculate Volume',
        //   action: () => this.calculateSurfaceVolume(),
        // },
      ],
      shortcuts: {
        2: 'switchTo3DView',
        3: 'switchToSurfaceView',
        escape: 'togglePanel',
        'ctrl+z': 'undoLastAction',
        space: 'toggleToolsPanel',
      },
      surfaceMesh: null,
      showSurface: false,
      legendMesh: null,
    };
  },
  computed: {
    isMobile() {
      return (
        this.$vuetify.breakpoint.mobile ||
        this.$vuetify.breakpoint.smAndDown ||
        this.$vuetify.breakpoint.width < 600
      );
    },

    surfaceBtnColor() {
      return this.showSurface ? '#0DD7B5' : 'rgba(255, 255, 255, 0.05)';
    },
    threeDBtnColor() {
      return this.showSurface ? 'rgba(255, 255, 255, 0.05)' : '#0DD7B5';
    },
    panelStyle() {
      return {
        'panel-header': true,
        'panel-header-collapsed': this.isPanelCollapsed,
      };
    },
    toolPanelStyle() {
      return {
        'tool-panel-header': true,
        'tool-panel-header-collapsed': this.isToolsPanelCollapsed,
      };
    },
  },
  mounted() {
    if (this.isMobile) {
      this.isPanelCollapsed = true;
      this.isToolsPanelCollapsed = true;
    }
    window.addEventListener('keydown', this.handleKeyboard);

    console.log('Component mounted');
    window.addEventListener('click', this.onPointClick);

    if ('ontouchmove' in window) {
      // Mobile device
      this.$refs.container?.addEventListener('touchstart', this.onTouchPoint, {
        passive: false,
      });
    } else {
      // Desktop device
      this.$refs.container?.addEventListener('click', this.onPointClick);
    }

    // window.addEventListener('touchstart', this.onTouchPoint);

    if (this.$route.query.result) {
      console.log('Found result query:', this.$route.query.result);
      this.moasureResult = atob(this.$route.query.result);

      this.toggleView('3d');
      console.log('Decoded result:', this.moasureResult);
      if (this.viewMode === '3d') {
        this.initThree();
      }
      this.processPointData();
    }
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    this.cleanup3D();
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    handleKeyboard(event) {
      // Get key or key combination
      let key = event.key.toLowerCase();

      if (event.ctrlKey && key !== 'control') key = 'ctrl+' + key;
      if (event.shiftKey && key !== 'shift') key = 'shift+' + key;
      if (event.altKey && key !== 'alt') key = 'alt+' + key;

      const action = this.shortcuts[key];

      if (action && typeof this[action] === 'function') {
        event.preventDefault(); // Prevent default browser action
        this[action]();

        this.showShortcutHint(action);
      }
    },
    showShortcutHint(action) {
      // Map actions to readable names
      const actionNames = {
        switchTo3DView: '3D View',
        switchToSurfaceView: 'Surface View',
        togglePanel: 'Toggle Panel',
        undoLastAction: 'Undo',
        toggleToolsPanel: 'Toggle Tools',
      };

      // alert(`Shortcut: ${actionNames[action] || action}`);
    },
    calculateSurfaceVolume() {
      if (!this.surfaceMesh) return 0;
      const geometry = this.surfaceMesh.geometry;
      const positions = geometry.attributes.position;
      const indices = geometry.index;

      let totalVolume = 0;
      let totalArea = 0;

      // Get height range
      let minHeight = Infinity;
      let maxHeight = -Infinity;
      for (let i = 0; i < positions.count; i++) {
        const y = positions.array[i * 3 + 1];
        minHeight = Math.min(minHeight, y);
        maxHeight = Math.max(maxHeight, y);
      }

      // Calculate volume and area for each triangle
      for (let i = 0; i < indices.count; i += 3) {
        const idx1 = indices.array[i];
        const idx2 = indices.array[i + 1];
        const idx3 = indices.array[i + 2];

        // Get triangle vertices
        const p1 = new THREE.Vector3(
          positions.array[idx1 * 3],
          positions.array[idx1 * 3 + 1],
          positions.array[idx1 * 3 + 2]
        );

        const p2 = new THREE.Vector3(
          positions.array[idx2 * 3],
          positions.array[idx2 * 3 + 1],
          positions.array[idx2 * 3 + 2]
        );

        const p3 = new THREE.Vector3(
          positions.array[idx3 * 3],
          positions.array[idx3 * 3 + 1],
          positions.array[idx3 * 3 + 2]
        );

        // Calculate triangle area
        const area = calculateTriangleArea(p1, p2, p3);
        totalArea += area;

        // Calculate prism volume for this triangle
        const centroidHeight = (p1.y + p2.y + p3.y) / 3 - minHeight;
        const volume = area * centroidHeight;
        totalVolume += volume;
      }

      // Apply scale factor correction
      const scaleFactor = 1.0; // Adjust if needed based on coordinate system
      totalVolume *= scaleFactor;
      totalArea *= scaleFactor;

      // Log debug info
      console.log({
        minHeight,
        maxHeight,
        heightDiff: maxHeight - minHeight,
        totalArea,
        totalVolume,
        pointCount: positions.count,
        triangleCount: indices.count / 3,
      });

      // Store and return values
      this.volume = totalVolume.toFixed(2);
      this.surfaceArea = totalArea.toFixed(2);

      return {
        volume: this.volume,
        area: this.area,
        baseHeight: minHeight.toFixed(2),
      };
    },

    switchToSurfaceView() {
      const cameraPosition = this.camera.position.clone();
      const controlsTarget = this.controls.target.clone();

      this.showSurface = true;
      this.processPointData();

      // Restore camera position and target to avoid cam position changed when togglng between 3d and surface
      this.camera.position.copy(cameraPosition);
      this.controls.target.copy(controlsTarget);
      this.controls.update();
    },
    switchTo3DView() {
      this.showSurface = false;

      // Remove surface and legend
      if (this.gradePlaneMesh) {
        this.scene.remove(this.gradePlaneMesh);
      }
      this.scene.remove(this.surfaceMesh);
      if (this.legendMesh) {
        this.scene.remove(this.legendMesh);
      }

      // Dispose of geometries and materials
      this.surfaceMesh.geometry.dispose();
      this.surfaceMesh.material.dispose();
      if (this.surfaceMesh.children.length > 0) {
        // Dispose of wireframe
        this.surfaceMesh.children[0].geometry.dispose();
        this.surfaceMesh.children[0].material.dispose();
      }
      this.surfaceMesh = null;

      if (this.legendMesh) {
        this.legendMesh.geometry.dispose();
        this.legendMesh.material.dispose();
        this.legendMesh = null;
      }
      // this.processPointData();
    },
    togglePanel() {
      this.isPanelCollapsed = !this.isPanelCollapsed;
    },
    toggleToolsPanel() {
      this.isToolsPanelCollapsed = !this.isToolsPanelCollapsed;
    },
    selectTool(toolId) {
      this.selectedTool = toolId;
      this.$emit('tool-selected', toolId);
      if (toolId == 'cut-fill') {
        const positions = this.surfaceMesh?.geometry.attributes.position;
        if (!positions) return;

        const heights = Array.from(
          { length: positions.count },
          (_, i) => positions.array[i * 3 + 1]
        );
        const minHeight = Math.min(...heights);
        const maxHeight = Math.max(...heights);
        Swal.fire({
          title: 'Enter Grade Height',
          html: `
        <div style="text-align: left; margin-bottom: 1em;">
          <p>Enter the height for grade plane calculation:</p>
          <p style="color: #666; font-size: 0.9em;">
            Min Height: ${minHeight.toFixed(2)}m<br>
            Max Height: ${maxHeight.toFixed(2)}m
          </p>
        </div>
      `,
          input: 'number',
          inputValue: minHeight.toFixed(2),
          inputAttributes: {
            step: '0.1',
            min: minHeight - 5, // Allow some flexibility below min
            max: maxHeight + 5, // Allow some flexibility above max
          },
          showCancelButton: true,
          confirmButtonColor: '#0DD7B5',
          cancelButtonColor: '#666',
          confirmButtonText: 'Calculate',
          width: 600,
          padding: '3em',
          color: 'black',
          customClass: {
            popup: 'dark-swal',
            confirmButton: 'swal-confirm-btn',
          },
          backdrop: `rgba(20, 18, 24, 0.8)`,
          inputValidator: (value) => {
            if (!value) {
              return 'Please enter a height value';
            }
            const numValue = parseFloat(value);
            if (isNaN(numValue)) {
              return 'Please enter a valid number';
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.gradePlaneHeight = parseFloat(result.value);
            this.colorMode = 'cutfill';
            this.calculateCutFill(parseFloat(result.value));
          }
        });
      }
      if (toolId != 'cut-fill') {
        this.cleanupGradePlane();
      }
    },
    cleanupGradePlane() {
      // Remove grade plane mesh
      if (this.gradePlaneMesh) {
        this.scene.remove(this.gradePlaneMesh);
        this.gradePlaneMesh.geometry.dispose();
        this.gradePlaneMesh.material.dispose();
        this.gradePlaneMesh = null;
      }

      //clear line

      if (this.measurementLine) {
        this.scene.remove(this.measurementLine);
        this.measurementLine.geometry.dispose();
        this.measurementLine.material.dispose();
        this.measurementLine = null;
      }

      // clear lines

      // Reset surface mesh colors to height-based coloring
      this.selectedPoints = [];
      if (this.surfaceMesh) {
        const geometry = this.surfaceMesh.geometry;
        const positions = geometry.attributes.position;

        // Find height range
        let minHeight = Infinity;
        let maxHeight = -Infinity;
        for (let i = 0; i < positions.count; i++) {
          const height = positions.array[i * 3 + 1];
          minHeight = Math.min(minHeight, height);
          maxHeight = Math.max(maxHeight, height);
        }

        // Create new colors based on height
        const colors = new Float32Array(positions.count * 3);
        for (let i = 0; i < positions.count; i++) {
          const height = positions.array[i * 3 + 1];
          const color = getColorForHeight(height, minHeight, maxHeight);
          colors[i * 3] = color.r;
          colors[i * 3 + 1] = color.g;
          colors[i * 3 + 2] = color.b;
        }

        // Update geometry with new colors
        geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

        // Ensure material is using vertex colors
        this.surfaceMesh.material.vertexColors = true;
        this.surfaceMesh.material.needsUpdate = true;
      }
    },
    openApp() {
      let url =
        'moasureapp://cmd=measure&mode=closed&return_link=https%3A%2F%2Fvideos.moasure.com%2Fapi%3Fresult';
      window.open(url, '_blank');
    },
    goBack() {
      this.$router.go(-1);
    },

    showCutFillHelp() {
      Swal.fire({
        title: 'Cut Plane Settings',
        text: 'Volume is calculated by projecting to a horizontal (flat) plane. You can change the projection to a sloped plane by entering a percentage, rise/run ratio or angle. You can also change the direction of the slope.',
        width: 600,
        padding: '3em',
        color: 'black',
        confirmButtonColor: 'black',
        borderRadius: '8',
        customClass: {
          popup: 'dark-swal',
          confirmButton: 'swal-confirm-btn',
        },
        backdrop: `rgba(20, 18, 24, 0.8)`,
      });
    },

    updateViewBox() {
      if (!this.pausePoints.length) return;

      const xValues = this.pausePoints.map((p) => p[0]);
      const yValues = this.pausePoints.map((p) => p[1]);

      const minX = Math.min(...xValues);
      const maxX = Math.max(...xValues);
      const minY = Math.min(...yValues);
      const maxY = Math.max(...yValues);

      const padding = 2;
      this.viewBox = `${minX - padding} ${minY - padding} ${
        maxX - minX + 2 * padding
      } ${maxY - minY + 2 * padding}`;
    },

    updatePathData() {
      if (!this.pausePoints.length) return;

      this.pathData = this.pausePoints.reduce((path, point, index) => {
        const command = index === 0 ? 'M' : 'L';
        return `${path} ${command} ${point[0]},${point[1]}`;
      }, '');
    },

    processPointData() {
      try {
        const routeData = atob(this.$route.query.result);
        if (!routeData) return;

        const data =
          typeof routeData === 'string' ? JSON.parse(routeData) : routeData;

        console.log('Parsed data:', data);
        const points = JSON.parse(data.Points);
        console.log('Points:', points);

        this.pausePoints = points;
        this.distance = data.Distance;

        if (this.viewMode === '2d') {
          this.updateViewBox();
          this.updatePathData();
        } else {
          this.createPointsAndLines();
        }
      } catch (error) {
        console.error('Error processing measurement data:', error);
      }
    },
    onWindowResize() {
      this.containerWidth = window.innerWidth;
      this.containerHeight = window.innerHeight;

      if (this.renderer) {
        this.renderer.setSize(this.containerWidth, this.containerHeight);
      }

      if (this.camera) {
        this.camera.aspect = this.containerWidth / this.containerHeight;
        this.camera.updateProjectionMatrix();
      }
    },

    addGridAndAxes() {
      if (!this.scene || !this.pausePoints) return;

      // Remove existing grid if any
      this.scene.children = this.scene.children.filter(
        (child) =>
          !(
            child instanceof THREE.GridHelper ||
            child instanceof THREE.AxesHelper
          )
      );

      // Calculate the bounds of all points
      const xCoords = this.pausePoints.map((p) => p[0]);
      const yCoords = this.pausePoints.map((p) => p[1]);
      const zCoords = this.pausePoints.map((p) => p[2]);

      const minX = Math.min(...xCoords);
      const maxX = Math.max(...xCoords);
      const minY = Math.min(...yCoords);
      const maxY = Math.max(...yCoords);
      const minZ = Math.min(...zCoords);
      const maxZ = Math.max(...zCoords);

      // Calculate the maximum dimension
      // Inside addGridAndAxes method
      const dimensions = [
        Math.abs(maxX - minX),
        Math.abs(maxY - minY),
        Math.abs(maxZ - minZ),
      ];

      // Take the largest horizontal dimension and add elevation range
      const horizontalSpread = Math.max(
        Math.abs(maxX - minX),
        Math.abs(maxY - minY)
      );
      const verticalSpread = Math.abs(maxZ - minZ);
      const maxDimension = Math.max(horizontalSpread, verticalSpread);

      // Calculate grid size with extra padding for elevation
      const gridSize = Math.ceil(maxDimension / 10) * 10 * 2;
      const divisions = Math.ceil(gridSize / 2);
      // Create and add the grid
      const gridHelper = new THREE.GridHelper(
        gridSize,
        divisions,
        0x888888,
        0x888888
      );
      gridHelper.position.y = 0;
      gridHelper.material.opacity = 0.4;
      gridHelper.material.transparent = true;
      this.scene.add(gridHelper);

      // Create custom axes
      const axesLength = gridSize / 2;

      // Create X axis (red)
      const xGeometry = new THREE.BufferGeometry();
      xGeometry.setAttribute(
        'position',
        new THREE.Float32BufferAttribute([0, 0, 0, axesLength, 0, 0], 3)
      );
      const xAxis = new THREE.Line(
        xGeometry,
        new THREE.LineBasicMaterial({ color: 0xff0000 })
      );

      // Create Z axis (blue)
      const zGeometry = new THREE.BufferGeometry();
      zGeometry.setAttribute(
        'position',
        new THREE.Float32BufferAttribute([0, 0, 0, 0, 0, axesLength], 3)
      );
      const zAxis = new THREE.Line(
        zGeometry,
        new THREE.LineBasicMaterial({ color: 0x0000ff })
      );

      // Add axes to scene
      this.scene.add(xAxis);
      this.scene.add(zAxis);

      // Update camera position and controls
      if (this.camera && this.controls) {
        // Center point of the data
        const centerX = (maxX + minX) / 2;
        const centerY = (maxY + minY) / 2;
        const centerZ = (maxZ + minZ) / 2;

        // Set camera position relative to center and size
        this.camera.position.set(
          centerX + gridSize,
          gridSize,
          centerZ + gridSize
        );
        this.controls.target.set(centerX, 0, centerZ);
        this.controls.update();
      }
    },
    createPointsAndLines() {
      if (!this.scene || !this.pausePoints.length) return;

      // Clear existing objects
      if (this.points) this.scene.remove(this.points);
      if (this.lines) this.scene.remove(this.lines);
      if (this.elevationLines) this.scene.remove(this.elevationLines);

      // Create points geometry
      const pointsGeometry = new THREE.BufferGeometry();
      const positions = new Float32Array(this.pausePoints.length * 3); // each point in 3d space needs 3 values (x,y,z), so the array size is 3x the number of points, e.g. if we have 10 pause points, we need to store 30 coordinates.

      let maxHeight = 0;
      this.pausePoints.forEach((point, i) => {
        positions[i * 3] = point[0]; // x
        positions[i * 3 + 1] = point[2]; // y (in 3d js, Y is elevation. In Moasure world it's Z, so we use point 2 instead of point 1 to map Moasure data correctly.
        positions[i * 3 + 2] = -point[1]; // z (negate point[1] (y in Moasure world) to flip forward/backward direction)
        maxHeight = Math.max(maxHeight, point[2]);
      });

      pointsGeometry.setAttribute(
        'position',
        new THREE.BufferAttribute(positions, 3)
      );

      // Main measurement points and lines
      const pointsMaterial = new THREE.PointsMaterial({
        color: 0xffffff,
        size: 1,
        sizeAttenuation: true,
      });

      this.points = new THREE.Points(pointsGeometry, pointsMaterial);
      this.scene.add(this.points);

      // Main connecting line
      const lineMaterial = new THREE.LineBasicMaterial({
        color: 0xffffff,
        linewidth: 3,
        opacity: 0.7,
        transparent: true,
      });

      this.lines = new THREE.Line(pointsGeometry, lineMaterial);
      this.scene.add(this.lines);

      // Add elevation lines
      const elevationGroup = new THREE.Group();
      const elevationMaterial = new THREE.LineDashedMaterial({
        // color: 0x444444,
        color: 0xffffff,
        linewidth: 0.5,
        dashSize: 0.05,
        gapSize: 0.02,
        opacity: 0.3,
        transparent: true,
      });

      // create vertical rise lines that go down from each pause point

      this.pausePoints.forEach((point) => {
        // Create vertical line geometry
        const lineGeometry = new THREE.BufferGeometry();
        const linePositions = new Float32Array([
          point[0],
          point[2], // use point[2] instead of point[1] as 3D JS considers Y to be elevation, so we have to swap Z for Y.
          -point[1], // swap direction
          point[0],
          0, // represents ground plane, so rise lines are drawn from the ground
          -point[1], // z (negate point[1] (y in Moasure world) to flip forward/backward direction)
        ]);
        lineGeometry.setAttribute(
          'position',
          new THREE.BufferAttribute(linePositions, 3)
        );
        // Compute line distances for dashed effect
        const lineDistances = new Float32Array(2);
        lineDistances[1] = point[2]; // Just the height (vertical distance)

        lineGeometry.setAttribute(
          'lineDistance',
          new THREE.BufferAttribute(lineDistances, 1)
        );

        // Create dashed line and add to group
        const line = new THREE.Line(lineGeometry, elevationMaterial);
        line.computeLineDistances(); // Required for dashed lines
        elevationGroup.add(line);
      });

      this.scene.add(elevationGroup);
      this.elevationLines = elevationGroup;

      if (this.showSurface) {
        this.createSurfaceMesh();
        this.setupLighting();
      }
      // Update camera position
      this.updateCameraPosition(maxHeight);
      this.addGridAndAxes();
    },
    createSurfaceMesh() {
      if (!this.scene || !this.pausePoints || this.pausePoints.length < 3)
        return;

      // Remove existing surface if any
      if (this.surfaceMesh) {
        this.scene.remove(this.surfaceMesh);
        this.surfaceMesh.geometry.dispose();
        this.surfaceMesh.material.dispose();
      }

      try {
        const geometry = createPerimeterTriangulation(this.pausePoints);
        if (!geometry) return;

        // Find height range for coloring
        const heights = this.pausePoints.map((p) => p[2]);
        const minHeight = Math.min(...heights);
        const maxHeight = Math.max(...heights);

        // Create vertex colors based on height
        const colors = new Float32Array(this.pausePoints.length * 3);
        this.pausePoints.forEach((point, i) => {
          const color = getColorForHeight(point[2], minHeight, maxHeight);
          colors[i * 3] = color.r;
          colors[i * 3 + 1] = color.g;
          colors[i * 3 + 2] = color.b;
        });

        geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
        geometry.computeVertexNormals();

        // Create material
        const material = new THREE.MeshPhongMaterial({
          vertexColors: true,
          transparent: true,
          opacity: 0.8,
          side: THREE.DoubleSide,
          flatShading: true,
          shininess: 30,
        });

        // Create and add mesh
        this.surfaceMesh = new THREE.Mesh(geometry, material);
        this.scene.add(this.surfaceMesh);

        // Add wireframe overlay
        const wireframeMaterial = new THREE.MeshBasicMaterial({
          color: 0x000000,
          wireframe: true,
          transparent: true,
          opacity: 0.1,
        });
        const wireframe = new THREE.Mesh(geometry, wireframeMaterial);
        this.surfaceMesh.add(wireframe);

        // Calculate volume and surface area
        this.calculateSurfaceVolume();
      } catch (error) {
        console.error('Error creating surface mesh:', error);
      }
    },
    calculateCutFill(enteredPlaneHeight) {
      if (!this.surfaceMesh) return;

      this.updateGradePlaneMesh();

      const geometry = this.surfaceMesh.geometry;
      const positions = geometry.attributes.position;
      const indices = geometry.index;

      let cutVolume = 0;
      let fillVolume = 0;

      // Create colors array for visualization
      const colors = new Float32Array(positions.count * 3);

      // Calculate volumes and set colors
      for (let i = 0; i < indices.count; i += 3) {
        const vertices = [];
        const baseVertices = [];

        // Get triangle vertices
        for (let j = 0; j < 3; j++) {
          const idx = indices.array[i + j];
          const x = positions.array[idx * 3];
          const y = positions.array[idx * 3 + 1];
          const z = positions.array[idx * 3 + 2];

          vertices.push(new THREE.Vector3(x, y, z));
          baseVertices.push(new THREE.Vector3(x, this.gradePlaneHeight, z));

          // Set colors based on whether point is above or below grade
          const color = new THREE.Color();
          if (y > this.gradePlaneHeight) {
            // Cut - Red
            color.setRGB(1, 0, 0);
            colors[idx * 3] = color.r;
            colors[idx * 3 + 1] = color.g;
            colors[idx * 3 + 2] = color.b;
          } else {
            // Fill - Blue
            color.setRGB(0, 0, 1);
            colors[idx * 3] = color.r;
            colors[idx * 3 + 1] = color.g;
            colors[idx * 3 + 2] = color.b;
          }
        }

        // Calculate triangle volume
        const area = calculateTriangleArea(
          vertices[0],
          vertices[1],
          vertices[2]
        );
        const avgHeight = (vertices[0].y + vertices[1].y + vertices[2].y) / 3;
        const volume = area * Math.abs(avgHeight - this.gradePlaneHeight);

        if (avgHeight > this.gradePlaneHeight) {
          cutVolume += volume;
        } else {
          fillVolume += volume;
        }
      }

      // Update geometry with new colors
      geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

      // Update materials to use vertex colors
      this.surfaceMesh.material.vertexColors = true;
      this.surfaceMesh.material.needsUpdate = true;

      // Store volumes
      this.cutVolume = Math.round(cutVolume * 100) / 100;
      this.fillVolume = Math.round(fillVolume * 100) / 100;

      return {
        cut: this.cutVolume,
        fill: this.fillVolume,
        net: this.cutVolume - this.fillVolume,
      };
    },
    updateGradePlaneMesh() {
      // Remove existing grade plane if it exists
      if (this.gradePlaneMesh) {
        this.scene.remove(this.gradePlaneMesh);
        this.gradePlaneMesh.geometry.dispose();
        this.gradePlaneMesh.material.dispose();
      }

      // Calculate bounds of measurement
      const xCoords = this.pausePoints.map((p) => p[0]);
      const zCoords = this.pausePoints.map((p) => -p[1]);

      const minX = Math.min(...xCoords);
      const maxX = Math.max(...xCoords);
      const minZ = Math.min(...zCoords);
      const maxZ = Math.max(...zCoords);

      // Make plane larger than measurement area
      const width = (maxX - minX) * 1.5;
      const depth = (maxZ - minZ) * 1.5;

      // Create semi-transparent plane
      const planeGeometry = new THREE.PlaneGeometry(width, depth);
      const planeMaterial = new THREE.MeshPhongMaterial({
        color: 0xcccccc,
        transparent: true,
        opacity: 0.2,
        side: THREE.DoubleSide,
        depthWrite: false,
      });

      this.gradePlaneMesh = new THREE.Mesh(planeGeometry, planeMaterial);
      this.gradePlaneMesh.rotation.x = -Math.PI / 2;
      this.gradePlaneMesh.position.set(
        (minX + maxX) / 2,
        this.gradePlaneHeight,
        (minZ + maxZ) / 2
      );

      this.scene.add(this.gradePlaneMesh);
    },
    toggleColorMode() {
      this.colorMode = this.colorMode === 'height' ? 'cutfill' : 'height';
      if (this.colorMode === 'cutfill') {
        this.calculateCutFill();
      } else {
        this.createSurfaceMesh(); // This will restore height-based coloring
      }
    },
    // Add elevation legend to the scene
    addElevationLegend(minHeight, maxHeight) {
      // Remove existing legend if any
      if (this.legendMesh) {
        this.scene.remove(this.legendMesh);
      }

      // Create legend geometry
      const legendGeometry = new THREE.PlaneGeometry(1, 5, 1, 10);
      const legendColors = new Float32Array(
        legendGeometry.attributes.position.count * 3
      );

      // Fill colors for legend vertices
      for (let i = 0; i < legendGeometry.attributes.position.count; i++) {
        const normalizedHeight =
          i / (legendGeometry.attributes.position.count - 1);
        const color = getColorForHeight(
          minHeight + normalizedHeight * (maxHeight - minHeight),
          minHeight,
          maxHeight
        );
        legendColors[i * 3] = color.r;
        legendColors[i * 3 + 1] = color.g;
        legendColors[i * 3 + 2] = color.b;
      }

      legendGeometry.setAttribute(
        'color',
        new THREE.BufferAttribute(legendColors, 3)
      );

      // Create legend material
      const legendMaterial = new THREE.MeshBasicMaterial({
        vertexColors: true,
        side: THREE.DoubleSide,
      });

      // Create and position legend mesh
      this.legendMesh = new THREE.Mesh(legendGeometry, legendMaterial);
      this.legendMesh.position.set(-10, 2, -10); // Adjust position as needed
      this.legendMesh.rotation.y = Math.PI / 4;
      this.scene.add(this.legendMesh);
    },
    setupLighting() {
      // Remove existing lights
      this.scene.children = this.scene.children.filter(
        (child) =>
          !(
            child instanceof THREE.AmbientLight ||
            child instanceof THREE.DirectionalLight
          )
      );

      // Add ambient light
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
      this.scene.add(ambientLight);

      // Add directional lights for better surface definition
      const dirLight1 = new THREE.DirectionalLight(0xffffff, 0.8);
      dirLight1.position.set(1, 1, 1);
      this.scene.add(dirLight1);

      const dirLight2 = new THREE.DirectionalLight(0xffffff, 0.4);
      dirLight2.position.set(-1, 0.5, -1);
      this.scene.add(dirLight2);
    },
    onPointClick(event) {
      event.stopPropagation();

      const container = this.$refs.container;

      if (!container) {
        console.error('Container reference is not available.');
        return;
      }

      // Calculate mouse position in normalized device coordinates (-1 to +1)
      const rect = container.getBoundingClientRect();
      this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

      if (!this.raycaster) {
        console.error('Raycaster is not initialized!');
        return;
      }

      // Configure Raycaster
      this.raycaster.params.Points.threshold = 0.8;
      this.raycaster.setFromCamera(this.mouse, this.camera);

      // Perform Raycasting
      const intersects = this.raycaster.intersectObject(this.points);

      if (intersects.length > 0) {
        const intersectedPoint = intersects[0];
        const index = intersectedPoint.index;
        const point = this.pausePoints[index];
        const rawX = intersectedPoint.point.x;
        const rawY = intersectedPoint.point.y;
        const rawZ = intersectedPoint.point.z;

        const x = this.roundToPrecision(rawX, 0.01);
        const y = this.roundToPrecision(-rawZ, 0.01); // Negate z to get original y
        const z = this.roundToPrecision(rawY, 0.01);
        this.selectedPoints.push(point);

        // Highlight selected point
        this.highlightPoint(point);

        console.log(`Point clicked at:\nX: ${x}, Y: ${y}, Z: ${z}`);
        // Swal.fire({
        //   title: 'Selected Point',
        //   text: `X: ${x}, Y: ${y}, Z: ${z}`,
        //   width: 600,
        //   padding: '3em',
        //   color: 'black',
        //   confirmButtonColor: 'black',
        //   borderRadius: '8',
        //   customClass: {
        //     popup: 'dark-swal',
        //     confirmButton: 'swal-confirm-btn',
        //   },
        //   backdrop: `rgba(20, 18, 24, 0.8)`,
        // });

        if (this.selectedPoints.length === 2) {
          this.calculateAndShowDistance();
        }

        if (this.selectedPoints.length == 3) {
          this.selectedPoints = [this.selectedPoints[2]];
          this.clearMeasurement();
        }

        // If we exceed 2 points, remove the first one (FIFO)
        if (this.selectedPoints.length > 2) {
          this.selectedPoints.shift();
          this.clearMeasurement();
          this.calculateAndShowDistance();
        }
      } else {
        console.log('No points intersected.');
      }
    },

    calculateAndShowDistance() {
      const [point1, point2] = this.selectedPoints;

      // Calculate 3D distance
      const distance = Math.sqrt(
        Math.pow(point2[0] - point1[0], 2) +
          Math.pow(point2[1] - point1[1], 2) +
          Math.pow(point2[2] - point1[2], 2)
      );

      // Calculate horizontal distance (ignoring height/Z)
      const horizontalDistance = Math.sqrt(
        Math.pow(point2[0] - point1[0], 2) + Math.pow(point2[1] - point1[1], 2)
      );

      // Calculate height difference
      const heightDifference = Math.abs(point2[2] - point1[2]);

      // Create or update measurement line
      this.showMeasurementLine(point1, point2);

      // Show measurement info

      this.run = horizontalDistance.toFixed(2);
      this.rise = heightDifference.toFixed(2);
      this.distance = distance;
      // Swal.fire({
      //   title: 'Cross Section',
      //   html: `
      //   <div style="text-align: left">
      //     <p>Length: ${distance.toFixed(2)} meter</p>
      //     <p>Rise: ${heightDifference.toFixed(2)} meter</p>
      //     <p>Run: ${horizontalDistance.toFixed(2)} meter</p>
      //   </div>
      // `,
      //   width: 600,
      //   padding: '3em',
      //   color: 'black',
      //   confirmButtonColor: 'black',
      //   borderRadius: '8',
      //   customClass: {
      //     popup: 'dark-swal',
      //     confirmButton: 'swal-confirm-btn',
      //   },
      //   backdrop: `rgba(20, 18, 24, 0.8)`,
      // });
    },

    showMeasurementLine(point1, point2) {
      // Clear existing measurement line
      this.clearMeasurement();

      // Create line geometry
      const geometry = new THREE.BufferGeometry().setFromPoints([
        new THREE.Vector3(point1[0], point1[2], -point1[1]),
        new THREE.Vector3(point2[0], point2[2], -point2[1]),
      ]);

      // Create line material
      const material = new THREE.LineBasicMaterial({
        color: 0xffff00, // Yellow color for measurement
        linewidth: 2,
        transparent: false,
        opacity: 1,
      });

      // Create and add line
      this.measurementLine = new THREE.Line(geometry, material);
      this.scene.add(this.measurementLine);

      this.addDistanceLabel(point1, point2);
    },

    addDistanceLabel(point1, point2) {
      // Calculate midpoint
      const midpoint = [
        (point1[0] + point2[0]) / 2,
        (point1[2] + point2[2]) / 2,
        -(point1[1] + point2[1]) / 2,
      ];

      // Create text sprite
      const distance = Math.sqrt(
        Math.pow(point2[0] - point1[0], 2) +
          Math.pow(point2[1] - point1[1], 2) +
          Math.pow(point2[2] - point1[2], 2)
      ).toFixed(2);

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = 256;
      canvas.height = 64;

      context.fillStyle = 'rgba(0, 0, 0, 0.8)';
      context.fillRect(0, 0, canvas.width, canvas.height);

      context.font = '24px Arial';
      context.fillStyle = 'white';
      context.textAlign = 'center';
      context.fillText(
        `${distance} meter`,
        canvas.width / 2,
        canvas.height / 2
      );

      const texture = new THREE.CanvasTexture(canvas);
      const spriteMaterial = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
      });

      const sprite = new THREE.Sprite(spriteMaterial);
      sprite.position.set(midpoint[0], midpoint[1], midpoint[2]);
      sprite.scale.set(2, 0.5, 1);

      this.measurementLabels.push(sprite);
      this.scene.add(sprite);
    },

    clearMeasurement() {
      // Remove measurement line
      if (this.measurementLine) {
        this.scene.remove(this.measurementLine);
        this.measurementLine.geometry.dispose();
        this.measurementLine.material.dispose();
        this.measurementLine = null;
      }

      // Remove measurement labels
      this.measurementLabels.forEach((label) => {
        this.scene.remove(label);
        label.material.map.dispose();
        label.material.dispose();
      });
      this.measurementLabels = [];
    },

    highlightPoint(point) {
      // Create a highlight sphere at the point
      const geometry = new THREE.SphereGeometry(0.3);
      const material = new THREE.MeshBasicMaterial({
        color: 907189,
        transparent: false,
        opacity: 1,
      });

      const sphere = new THREE.Mesh(geometry, material);
      this.sphere = sphere;

      sphere.position.set(point[0], point[2], -point[1]);
      this.scene.add(sphere);

      // Remove highlight after 2 seconds
      // setTimeout(() => {
      //   this.scene.remove(sphere);
      //   geometry.dispose();
      //   material.dispose();
      // }, 2000);
    },

    onTouchPoint(event) {
      event.preventDefault();

      const container = this.$refs.container;
      if (!container || !this.scene || !this.points) return;

      // Get touch coordinates
      const rect = container.getBoundingClientRect();
      const touch = event.touches?.[0] || event.changedTouches?.[0] || event;
      this.raycaster.params.Points.threshold = 0.1; // Adjust if necessary

      // Calculate normalized coordinates (-1 to +1)
      this.mouse.x = ((touch.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouse.y = -((touch.clientY - rect.top) / rect.height) * 2 + 1;

      // Update raycaster
      this.raycaster.setFromCamera(this.mouse, this.camera);

      // Only intersect with the points object
      const intersects = this.raycaster.intersectObject(this.points);

      if (intersects.length > 0) {
        const intersectedPoint = intersects[0];
        const index = intersectedPoint.index;
        const point = this.pausePoints[index];

        // Get the original point data
        const originalPoint = this.pausePoints[index];

        if (originalPoint) {
          const [x, y, z] = originalPoint;
          this.selectedPoints.push(point);

          this.highlightPoint(point);

          Swal.fire({
            title: 'Selected Point',
            text: `X: ${x.toFixed(2)}\nY: ${y.toFixed(2)}\nZ: ${z.toFixed(2)}`,
            width: 600,
            padding: '3em',
            color: 'black',
            confirmButtonColor: 'black',
            borderRadius: '8',
            customClass: {
              popup: 'dark-swal',
              confirmButton: 'swal-confirm-btn',
            },
            backdrop: `rgba(20, 18, 24, 0.8)`,
          });
          if (this.selectedPoints.length === 2) {
            this.calculateAndShowDistance();
          }

          if (this.selectedPoints.length == 3) {
            this.selectedPoints = [this.selectedPoints[2]];
            this.clearMeasurement();
          }

          // If we exceed 2 points, remove the first one (FIFO)
          if (this.selectedPoints.length > 2) {
            this.selectedPoints.shift();
            this.clearMeasurement();
            this.calculateAndShowDistance();
          }
        }
      }
    },

    roundToPrecision(value, precision = 0.01) {
      return Math.round(value / precision) * precision;
    },
    updateCameraPosition(maxHeight) {
      if (!this.camera || !this.points) return;

      // Calculate bounding box of points
      const bbox = new THREE.Box3().setFromObject(this.points);
      const center = bbox.getCenter(new THREE.Vector3());
      const size = bbox.getSize(new THREE.Vector3());

      // Calculate distance needed to view all points
      const maxDim = Math.max(size.x, size.y, size.z);
      const fov = this.camera.fov * (Math.PI / 180);
      const cameraDistance = Math.abs(maxDim / Math.sin(fov / 2)) * 0.6;

      this.camera.position.set(
        center.x + cameraDistance,
        center.y + cameraDistance,
        center.z + cameraDistance + maxHeight * 1.5
      );
      this.camera.lookAt(center);
      this.camera.updateProjectionMatrix();
    },

    toggleView(mode) {
      console.log('Toggling view to:', mode);
      this.viewMode = mode;
      if (mode === '3d') {
        // Wait for DOM to update
        setTimeout(() => {
          const container = this.$refs.container;
          if (!container) {
            console.error('Container still not found after delay');
            return;
          }
          console.log(
            'Container found, dimensions:',
            container.clientWidth,
            container.clientHeight
          );
          this.initThree();
          this.createPointsAndLines();
          this.addGridAndAxes();
        }, 100); // Small delay to ensure container is mounted
      } else {
        this.cleanup3D();
        this.updateViewBox();
        this.updatePathData();
      }
    },

    initThree() {
      console.log('Initializing Three.js');
      const container = this.$refs.container;
      if (!container) {
        console.error('Container not found');
        return;
      }

      // Get container dimensions
      const width = container.clientWidth || 800; // Fallback width
      const height = container.clientHeight || width;

      if (width === 0 || height === 0) {
        console.error('Invalid container dimensions:', width, height);
        return;
      }

      console.log('Container dimensions:', width, height);

      // Scene setup
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color('#141218');

      // Camera
      this.camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1000);
      this.camera.position.set(50, 50, 50);
      this.camera.lookAt(0, 0, 0);

      // Renderer
      try {
        this.renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
        });
        this.renderer.setSize(width, height);
        this.renderer.setPixelRatio(window.devicePixelRatio);

        // Clear container and append renderer
        container.innerHTML = '';
        container.appendChild(this.renderer.domElement);
        this.renderer.domElement.style.borderRadius = '0px';

        // Controls
        this.controls = new OrbitControls(
          this.camera,
          this.renderer.domElement
        );
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.05;

        // Lighting
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.scene.add(ambientLight);

        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
        directionalLight.position.set(10, 10, 10);
        this.scene.add(directionalLight);

        // Start animation loop
        this.animate();

        console.log('Three.js initialized successfully');
        return true;
      } catch (error) {
        console.error('Error initializing Three.js:', error);
        return false;
      }
    },

    animate() {
      const animate = () => {
        if (!this.renderer || !this.scene || !this.camera) return;

        requestAnimationFrame(animate);
        if (this.controls) {
          this.controls.update();
        }
        this.renderer.render(this.scene, this.camera);
      };
      animate();
    },
    cleanup3D() {
      if (this.scene) {
        this.scene.clear();
        if (this.renderer) {
          this.renderer.dispose();
        }
        if (this.controls) {
          this.controls.dispose();
        }
      }
      this.scene = null;
      this.renderer = null;
      this.controls = null;
      this.points = null;
      this.lines = null;
      this.selectedPoints = [];
    },
  },
  watch: {
    moasureResult: {
      handler() {
        this.processPointData();
      },
    },
  },
};
</script>

<style scoped>
.grading-panel {
  width: 100%;
  min-height: 100vh;
  background: #141218;
  color: white;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 80px;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #141218;
  color: #ffffff;
  border-bottom: 1px solid #1f1f1f;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: white;
  transition: background 0.2s ease;
}

.arrow-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: solid white;
  border-width: 2px 2px 0 0;
  transform: rotate(-135deg);
  margin-left: 4px;
}

.help-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.help-icon {
  cursor: pointer;
}

.control-group {
  padding: 1rem;
  border-bottom: 1px solid #211f26;
}

.action-buttons {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  background: #141218;
  border-top: 1px solid #211f26;
  z-index: 100;
}

.action-buttons button {
  flex: 1;
  padding: 0.75rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 1rem;
  min-height: 48px;
}

.three-container {
  width: 100%;

  aspect-ratio: 1;
  position: relative;
  padding-left: 0px;
  margin-left: 0px;
  min-height: 400px;
  /* margin: 16px; */
  /* margin-left: 16px; */
  max-height: 500px;
  border: 1px solid #333;
  background: #141218;
  display: block;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .three-container {
    width: 100%;
    aspect-ratio: 1;
    position: relative;
    min-height: 400px;
    border: 1px solid #333;
    background: #141218;
    display: block;
  }
}

.drawing-container {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 0px;
  padding-bottom: 0px;
  background: #141218;
  min-height: 400px;
}

.floating-panel {
  position: absolute;
  right: 0px;
  margin-right: 16px;
  background: rgba(26, 26, 26, 0.9);
  border: 1px solid #333;
  min-width: 50px;
  z-index: 10;
  transition: all 0.3s ease;
  /* border-radius: 0px 0px 0px 12px; */
  border-radius: 12px;
}

.object-floating-panel {
  position: absolute;
  left: 16px;
  top: 16px;
  background: rgba(26, 26, 26, 0.9);
  border: 1px solid #333;
  min-width: 50px;
  z-index: 10;
  transition: all 0.3s ease;
  /* border-radius: 0 0 12px 0px; */
  border-radius: 12px;
}

.measurement-panel {
  position: absolute;
  left: 0;
  top: 60px;
  border-radius: 0 8px 8px 0;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #333;
}

.panel-header-collapsed {
  border-bottom: 0px;
}

.tool-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #333;
}

.tool-panel-header-collapsed {
  border-bottom: 0px;
}

.panel-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.panel-toggle {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.panel-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.panel-content {
  padding: 16px;
  width: 280px;
}

.measurement-info {
  margin-bottom: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.info-label {
  color: #888;
}

.info-value {
  font-weight: 500;
}

.selected-points {
  border-top: 1px solid #333;
  padding-top: 16px;
}

.view-btns {
  padding-left: 16px;
  border-top: 1px solid #333;
  padding-top: 16px;
}

.section-title {
  font-size: 14px;
  margin-bottom: 12px;
  color: #888;
}

.point-item {
  background: rgba(255, 255, 255, 0.05);
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.point-index {
  display: block;
  color: #888;
  font-size: 12px;
  margin-bottom: 4px;
}

.point-coords {
  display: block;
  font-family: monospace;
  font-size: 12px;
}

.relative {
  position: relative;
}

.tools-panel {
  top: 16px;
  right: 0;
}

.panel-collapsed {
  width: auto;
}

.panel-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

.panel-toggle {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.panel-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.panel-content {
  padding: 16px;
  width: 280px;
}

.measurement-info {
  margin-bottom: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.info-label {
  color: #888;
}

.info-value {
  font-weight: 500;
  color: #ffffff;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.tool-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tool-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.tool-item.active {
  /* background: #0dd7b5; */
  border: 1px solid #0dd7b5;
}

.tool-label {
  margin-top: 8px;
  font-size: 12px;
  color: #ffffff;
}

.selected-points {
  border-top: 1px solid #333;
  padding-top: 16px;
}

.section-title {
  font-size: 14px;
  margin-bottom: 12px;
  color: #888;
}

.point-item {
  background: rgba(255, 255, 255, 0.05);
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.point-index {
  display: block;
  color: #888;
  font-size: 12px;
  margin-bottom: 4px;
}

.point-coords {
  display: block;
  font-family: monospace;
  font-size: 12px;
  color: #ffffff;
}

.v-icon {
  font-size: 24px !important;
  color: #ffffff;
}

.btn-text {
  color: white;
}

.secondary-btn-text {
  color: #0dd7b5;
}

.secondary-background {
  background-color: #0dd7b5;
}
</style>